// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__269VR","top":"styles_top__2h6Wt"};